<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10.9492" cy="10.0002" r="7.50312" fill="currentColor" stroke="inherit" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.98468 10.2829L9.79127 12.0895L9.77959 12.0778L13.8555 8.00195" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
